const rankingItems = [
  { id: 1, rank: 1, title: '剑与魔法', subtitle: '韩漫 · 奇幻冒险', change: 'up', hot: '本周上升3位', views: '128万' },
  { id: 2, rank: 2, title: '命运轮回', subtitle: '日漫 · 转生异世界', change: 'same', hot: '连续霸榜8周', views: '203万' },
  { id: 3, rank: 3, title: '拳皇之路', subtitle: '韩漫 · 热血格斗', change: 'up', hot: '本周上升5位', views: '156万' },
  { id: 4, rank: 4, title: '末日生存指南', subtitle: '韩漫 · 末世生存', change: 'down', hot: '本周下降1位', views: '112万' },
  { id: 5, rank: 5, title: '暗夜追踪者', subtitle: '日漫 · 悬疑推理', change: 'up', hot: '本周上升2位', views: '85万' },
  { id: 6, rank: 6, title: '甜蜜陷阱', subtitle: '韩漫 · 恋爱甜宠', change: 'same', hot: '新番持续上升', views: '96万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            本周最受欢迎的漫画作品排行
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                index < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-300 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-200 text-primary-700'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.subtitle}</span>
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>{item.views}次阅读
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    {item.change === 'up' ? (
                      <i className="ri-arrow-up-line text-secondary-600"></i>
                    ) : item.change === 'down' ? (
                      <i className="ri-arrow-down-line text-accent-600"></i>
                    ) : (
                      <i className="ri-subtract-line text-foreground-400"></i>
                    )}
                    {item.hot}
                  </span>
                </div>
              </div>

              <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap hover:text-primary-700 transition-colors">
                阅读 <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}